import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { lazy, string } from "yup";

import { TextInputField } from "./TextInputField";
import { TextSummaryField } from "./TextSummaryField";
import { FieldType } from "../types";

export function TextField(
  field: components["schemas"]["TextCheckField"]
): FieldType<components["schemas"]["TextCheckField"]> {
  return {
    field,
    inputElement: <TextInputField key={field.name} field={field} />,
    summaryElement: () => <TextSummaryField key={field.name} field={field} />,
    initialValue: field.value ?? "",
    schema: lazy(() => {
      if (field.required) {
        return string().required(t("This field is required"));
      }
      return string();
    }),
  };
}
